import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import LanguageToggle from "../components/LanguageToggle";
import { BrandMark } from "../components/Logo";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (ex) {
      setErr(ex.response?.data?.detail || ex.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center grain relative px-4">
      <div className="absolute top-6 right-6 z-10"><LanguageToggle /></div>
      <Link to="/" className="absolute top-6 left-6 z-10" data-testid="brand-link">
        <BrandMark />
      </Link>
      <div className="w-full max-w-md glass rounded-3xl p-8 lg:p-10 anim-stagger relative">
        <h1 className="text-3xl font-extrabold text-white tracking-tight">{t("auth.forgot_title")}</h1>
        <p className="mt-2 text-sm text-slate-400">{t("auth.forgot_sub")}</p>

        {done ? (
          <div className="mt-8 space-y-4">
            <div className="rounded-xl bg-emerald-400/10 border border-emerald-400/20 p-4 text-sm text-emerald-300" data-testid="forgot-success">
              {t("auth.forgot_done")}
            </div>
            <Link to="/login" className="btn-ghost inline-flex items-center gap-2 w-full justify-center" data-testid="back-to-login">
              <ArrowLeft className="h-4 w-4" /> {t("auth.go_login")}
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.email")}</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark mt-1.5" />
            </div>
            {err && <div className="text-rose-400 text-sm" data-testid="forgot-error">{err}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="forgot-submit">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />}
              {t("auth.forgot_submit")}
            </button>
            <Link to="/login" className="text-sm text-slate-400 hover:text-white inline-flex items-center gap-2 mx-auto w-full justify-center" data-testid="forgot-back">
              <ArrowLeft className="h-3.5 w-3.5" /> {t("auth.go_login")}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
